"use client"

import * as React from "react"
import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
   Popover,
   PopoverContent,
   PopoverTrigger,
} from "@/components/ui/popover"

export function DateRangePicker({ value, onChange, className }) {
   return (
      <div className={cn("grid gap-2", className)}>
         <Popover>
            <PopoverTrigger asChild>
               <Button
                  id="date"
                  variant={"outline"}
                  className={cn(
                     "w-[300px] justify-start text-left font-normal",
                     !value && "text-muted-foreground"
                  )}
               >
                  <CalendarIcon className="mr-2 h-4 w-4" />
                  {value?.from ? (
                     value.to ? (
                        <>
                           {format(value.from, "LLL dd, y")} -{" "}
                           {format(value.to, "LLL dd, y")}
                        </>
                     ) : (
                        format(value.from, "LLL dd, y")
                     )
                  ) : (
                     <span>Pick a date range</span>
                  )}
               </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
               <Calendar
                  initialFocus
                  mode="range"
                  defaultMonth={value?.from}
                  selected={value}
                  onSelect={onChange}
                  numberOfMonths={2}
               />
            </PopoverContent>
         </Popover>
      </div>
   );
}
